import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../store';
import { firestore, firestoreQuery } from '../firebase';
import { UserReport } from '../types';


interface UserReportsState {
  reports: {
    [ userId: string ]: UserReport[]
  },
  loading: boolean;
}

const initialState: UserReportsState = {
  reports: {},
  loading: false,
}



const service = createSlice({
  name: 'userReports',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<{ isLoading: boolean, userId: string }>): UserReportsState {
      let newState = { ...state, loading: action.payload.isLoading };

      if (!action.payload.isLoading) {
        newState = {
          ...newState,
          reports: {
            ...newState.reports,
            [action.payload.userId]: []
          },
        }
      }

      return newState;
    },
    setReports(state, action: PayloadAction<{userId: string, reports: UserReport[]}>): UserReportsState {
      return { 
        ...state, 
        reports: {
          ...state.reports,
          [action.payload.userId]: action.payload.reports,
        }, 
        loading: false,
      }
    },

  }
});



const loadReports = (userId: string): AppThunk => async (dispatch, getState) => {
  if (getState().userReports.reports[userId]) {
    return;
  }
  
  dispatch(service.actions.setLoading({
    userId,
    isLoading: true,
  }));

  const queryFromMe = firestore.collection('user_reports')
    .where('fromUserId', '==', userId)
    .orderBy('createTime', 'desc')
    .limit(250);

  const queryToMe = firestore.collection('user_reports')
    .where('userId', '==', userId)
    .orderBy('createTime', 'desc')
    .limit(250);

  const fromMe = await firestoreQuery<UserReport>(queryFromMe);
  const toMe = await firestoreQuery<UserReport>(queryToMe);

  dispatch(service.actions.setReports({
    userId,
    reports: [
      ...fromMe.list,
      ...toMe.list,
    ]
  }));
}



export const actions = {
  loadReports,
}

export default service.reducer;